import { render, staticRenderFns } from "./ClubRebelde.vue?vue&type=template&id=5ac41d82&scoped=true&"
import script from "./ClubRebelde.vue?vue&type=script&lang=js&"
export * from "./ClubRebelde.vue?vue&type=script&lang=js&"
import style0 from "./ClubRebelde.vue?vue&type=style&index=0&id=5ac41d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac41d82",
  null
  
)

export default component.exports